import { render, staticRenderFns } from "./ColoursPage.vue?vue&type=template&id=f999cdf2"
import script from "./ColoursPage.vue?vue&type=script&lang=js"
export * from "./ColoursPage.vue?vue&type=script&lang=js"
import style0 from "./ColoursPage.vue?vue&type=style&index=0&id=f999cdf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports